import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ReactLoading from 'react-loading'
import { deleteCategory, closeDeleteCategoryModal } from 'redux/actions/categories'

const DeleteModal = ({ isOpen, closeModal, category, deleteCategory, isLoading, source, history }) => !category ? null : (
  <Modal isOpen={isOpen} fade={false} toggle={closeModal} className="warning">
    <ModalHeader toggle={closeModal}>Eliminar Categoría</ModalHeader>
    <ModalBody>
      Estás seguro de que quieres borrar la categoría {category.name} ?
    </ModalBody>
    <ModalFooter>
      <Button disabled={isLoading} color="warning" className="mr-1" onClick={() => deleteCategory({category, source, history})}>
        {isLoading && <ReactLoading type="spinningBubbles" color="#fff" height={10} width={10} className="d-inline-block mr-4 ml-2" />}
        Eliminar
      </Button>
      <Button disabled={isLoading} color="primary" onClick={closeModal}>Cancelar</Button>
    </ModalFooter>
  </Modal>
)

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  category: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  source: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  deleteCategory: PropTypes.func.isRequired,
}

const mapStateToProps = ({ categories: { source, openedDeleteCategoryModal, selectedCategory, deletingCategory }}) => {
  return ({
    source,
    isOpen: openedDeleteCategoryModal,
    category: selectedCategory,
    isLoading: deletingCategory
  })
}

const mapDispatchToProps = dispatch => ({
  deleteCategory: info => dispatch(deleteCategory(info)),
  closeModal: () => dispatch(closeDeleteCategoryModal()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteModal))
